module.exports = __webpack_public_path__ + "static/media/blog-blogger-blogging-svgrepo-com.d410fa50.svg";